module.exports = {"latentSignal":["Latent Signal","レイテントシグナル"],"home":["Home","ホーム"],"mailingList":{"title":["Join Our Mailing List","メーリングリストに登録しませんか？"],"subtitle":["We won't spam you... too much!","面白いものを送るよ！"],"email":["Email","メールアドレス"],"button":["Subscribe","登録"],"successHeader":["All sorted :)","登録完了 ：）"],"successMessage":["'${email}' was subscribed.","「${email}」登録されました。"],"errorHeader":["Sorry, we couldn't do that :(","ごめんなさい、登録に失敗しました　：（"]},"footer":{"creator":["Created by Morrison Cole","作成者：モリソン コール"]}}


//////////////////
// WEBPACK FOOTER
// ./src/localisation/Translations.json
// module id = 834
// module chunks = 0